$(document).ready(function () {
    $(document).on('click', '.cars-tab, .vans-tab',
        function (e) {
            e.preventDefault();
            if (window.location.pathname !== $(this).data('completeurl')) {
                window.location = $(this).data('completeurl');
            }
        });

    $(document).on('click', '#business_button',
        function (e) {
            $('.js-options-loader').fadeIn();
            var form = $("#pricing-filter-form");
            $.ajax(
                {
                    url: form.attr('action'),
                    data: {
                        "PricingType": "Business",
                        "VehicleType": $('.hidden-xs.tabs.vehicle-search__tabs.clearfix').find('.active').text()
                    },
                    type: "GET",
                    success: function (data) {
                        $('#business_button').removeClass('btn-filter-inactive').addClass('is-active');
                        $('#personal_button').removeClass('is-active').addClass('btn-filter-inactive');
                        $(".topTwentyListing").html(data);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', '#personal_button',
        function (e) {
            $('.js-options-loader').fadeIn();
            var form = $("#pricing-filter-form");
            $.ajax(
                {
                    url: form.attr('action'),
                    data: {
                        "PricingType": "Personal",
                        "VehicleType": $('.hidden-xs.tabs.vehicle-search__tabs.clearfix').find('.active').text()
                    },
                    type: "GET",
                    success: function (data) {
                        $('#personal_button').removeClass('btn-filter-inactive').addClass('is-active');
                        $('#business_button').removeClass('is-active').addClass('btn-filter-inactive');
                        $(".topTwentyListing").html(data);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });
});